import React, {Component} from 'react';
import {FaTrash, FaEdit, FaPowerOff, FaToggleOn, FaPlusSquare, FaMinusSquare} from "react-icons/fa";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import  ListProductComponent from  './ListProductComponent';

class ListGroupProductComponent extends Component {

    listProduct = () => {
        if ( this.props.groupProduct.products.length ) {
            return (
                this.props.groupProduct.products.map( (product, index) => {
                    return (
                        <ListProductComponent
                            key={index}
                            product={product}
                            showModal={ (keyAction, action) => this.props.showModal(keyAction, action) }
                        />
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan={15} className="text-center text-danger">
                        Không có dữ liệu sản phẩm của nhóm sản phẩm { this.props.groupProduct.name }
                    </td>
                </tr>
            )
        }
    }

    render() {
        return (
            <>
                <tr>
                    <td>
                        {
                            this.props.groupProduct.isClose ? (
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Mở
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="button-list-product btn p-0 mr-3"
                                            onClick={ () => this.props.showProduct( this.props.keyAction ) }
                                    >
                                        <FaPlusSquare />
                                    </button>
                                </OverlayTrigger>
                            ) : (
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Ẩn
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="button-list-product btn p-0 mr-3"
                                            onClick={ () => this.props.showProduct( this.props.keyAction ) }
                                    >
                                        <FaMinusSquare />
                                    </button>
                                </OverlayTrigger>
                            )
                        }
                    </td>
                    <td>
                        <strong>Nhóm sản phẩm: { this.props.groupProduct.name }</strong>
                    </td>
                    <td>
                        { this.props.groupProduct.textType }
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                        {
                            this.props.groupProduct.hidden ? (
                                <span className="text-danger">Ẩn</span>
                            ) : (
                                <span className="text-success">Hiện</span>
                            )
                        }
                    </td>
                    <td></td>
                    <td>
                        {
                            this.props.groupProduct.hidden ? (
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Hiện nhóm sản phẩm
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button className="btn btn-success btn-sm mr-1 text-light"
                                            onClick={ () => this.props.showModal( this.props.keyAction, 'active' ) }
                                    >
                                        <FaToggleOn />
                                    </button>
                                </OverlayTrigger>
                            ) : (
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Ẩn nhóm sản phẩm
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button className="btn btn-danger btn-sm mr-1 text-light"
                                            onClick={ () => this.props.showModal( this.props.keyAction, 'hidden' ) }
                                    >
                                        <FaPowerOff />
                                    </button>
                                </OverlayTrigger>
                            )
                        }
                        <OverlayTrigger
                            delay={{ hide: 450, show: 300 }}
                            overlay={(props) => (
                                <Tooltip {...props}>
                                    Chỉnh sửa nhóm sản phẩm
                                </Tooltip>
                            )}
                            placement="top"
                        >
                            <button type="button" className="btn btn-warning btn-sm mr-1 text-light" onClick={ () => this.props.showModal( this.props.keyAction, 'editGroup' ) }>
                                <FaEdit />
                            </button>
                        </OverlayTrigger>
                        <OverlayTrigger
                            delay={{ hide: 450, show: 300 }}
                            overlay={(props) => (
                                <Tooltip {...props}>
                                    Xóa nhóm sản phẩm
                                </Tooltip>
                            )}
                            placement="top"
                        >
                            <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.keyAction, 'deleteGroup' ) }>
                                <FaTrash />
                            </button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {
                    !this.props.groupProduct.isClose ? (
                        this.listProduct()
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default ListGroupProductComponent;